import { render, staticRenderFns } from "./ModuleDetailPlugin.vue?vue&type=template&id=bf4a93da&scoped=true"
import script from "./ModuleDetailPlugin.vue?vue&type=script&lang=js"
export * from "./ModuleDetailPlugin.vue?vue&type=script&lang=js"
import style0 from "./ModuleDetailPlugin.vue?vue&type=style&index=0&id=bf4a93da&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf4a93da",
  null
  
)

export default component.exports